export function countEmAbertoActiveFilters(filters) {
  if (!filters) return 0;
  return (
    (filters.retorno === 'sim' || filters.retorno === 'nao' ? 1 : 0) +
    filters.cidade.length +
    filters.bairro.length +
    filters.cliente.length +
    filters.tipoOS.length +
    filters.sla.length +
    filters.equipamento.length +
    filters.status.length +
    (filters.tecnicoInicial?.length || 0) +
    filters.defeitoDescricao.length +
    filters.defeitoAlert.length +
    filters.defeitoClassification.length +
    filters.defeitoSeverity.length
  );
}
